import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SharedState } from "./shared.reducer";
import { Tag, toEntityDict } from "@prism/prism-shared";

export const sharedState = createFeatureSelector<SharedState>('shared')

export const getTags = createSelector(
    sharedState,
    (state: SharedState): Tag[] => state.tags
)

// above are selectors that ONLY use sharedState
// =========================================================
// below are selectors that are built with selectors above

export const getTagsDict = createSelector(
    getTags,
    (tags: Tag[]): Record<string, Tag> => toEntityDict<Tag>(tags)
)